import { postApiLogin, postApiLogout } from '@/api/auth'
import { getAccessToken, setAccessToken, removeAccessToken } from '@/utils/localStorage'


export default {
	namespaced: true,
	state: {
		accessToken: getAccessToken()
	},
	getters: {
		IS_AUTH: state => state.accessToken ? true : false
	},
	mutations: {
		SET_AUTH_ACCESS_TOKEN: (state, accessToken) => state.accessToken = accessToken,
		REMOVE_AUTH_ACCESS_TOKEN: (state) => state.accessToken = null
	},
	actions: {
		postApiLogin({ commit }, params) {
			return new Promise((resolve, reject) => {
				postApiLogin(params).then(res => {
					commit('SET_AUTH_ACCESS_TOKEN', res.data.access_token)
					setAccessToken(res.data.access_token)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		postApiLogout({ commit }) {
			return new Promise((resolve, reject) => {
				postApiLogout().then(res => {
					commit('REMOVE_AUTH_ACCESS_TOKEN')
					removeAccessToken()

					resolve(res)
				}).catch(error => reject(error))
			})
		},
	}
}